import { createContext } from "react";

const defaultValue = {
  handleInit: null,
  isReady: null,
  api: null,
};

export default createContext(defaultValue);
